<script setup lang="ts">
/** Section « Périmètre » — cocher les sujets concernés (capture DT, section 4). */
import { Squares2X2Icon } from '@heroicons/vue/24/outline'
import type { AccompScope } from '@/v2/accompagnement/api/accompagnementTypes'
import { ACCOMP_SCOPE_OPTIONS } from '@/v2/accompagnement/constants/accompagnementConstants'

const scope = defineModel<AccompScope[]>('scope', { required: true })

function toggle(value: AccompScope, checked: boolean) {
  const set = new Set(scope.value)
  if (checked) set.add(value)
  else set.delete(value)
  scope.value = [...set]
}
</script>

<template>
  <section class="card border border-base-300 bg-base-100 shadow-sm" aria-labelledby="accomp-scope-title">
    <div class="card-body gap-3 p-4 md:p-6">
      <h2 id="accomp-scope-title" class="card-title flex items-center gap-2 text-lg font-semibold">
        <Squares2X2Icon class="h-5 w-5 text-primary" aria-hidden="true" />
        Périmètre
      </h2>
      <p class="text-sm text-base-content/70">Cochez les sujets concernés.</p>
      <div class="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
        <label
          v-for="opt in ACCOMP_SCOPE_OPTIONS"
          :key="opt.value"
          class="flex cursor-pointer items-center gap-2"
        >
          <input
            type="checkbox"
            class="checkbox checkbox-primary checkbox-sm"
            :checked="scope.includes(opt.value)"
            @change="toggle(opt.value, ($event.target as HTMLInputElement).checked)"
          />
          <span class="text-base">{{ opt.label }}</span>
        </label>
      </div>
    </div>
  </section>
</template>
